export const maskCpf = (value: string) => {
    if (value.length >= 11) {
        return ""+value
            .match(/\d/g)
            ?.slice(0, 11)
            .map((c: string, i: number) => { if (i === 3 || i === 6) return '.' + c; if (i === 9) return '-' + c; return c; })
            .join('');
    }else{
        return value 
    }
}

export const unMaskCpf = (value: string) =>{
    return value.replaceAll(/[.-]/g, '')?.slice(0, 11)
}